import { createContext } from 'react';

const ArtworkDataContext = createContext({});

export default ArtworkDataContext;
